import React from 'react';

export interface Tab {
  id: string;
  label: string;
  content: React.ReactNode;
}

export interface TabsProps {
  tabs: Tab[];
  activeTab: string;
  onTabChange: (tabId: string) => void;
}

const Tabs = (props: TabsProps) => {
  return (
    <div className="w-full">
      <div className="flex justify-center mb-4 border-b border-gray-200">
        {props.tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => props.onTabChange(tab.id)}
            className={`
              whitespace-nowrap py-3 px-6 text-sm font-medium border-b-2 -mb-px
              ${props.activeTab === tab.id
                ? 'text-brand-electric-blue border-brand-electric-blue'
                : 'text-gray-500 border-transparent hover:text-brand-dark-blue'
              }
            `}
            aria-current={props.activeTab === tab.id ? 'page' : undefined}
          >
            {tab.label}
          </button>
        ))}
      </div>
      <div>
        {props.tabs.find((tab) => tab.id === props.activeTab)?.content}
      </div>
    </div>
  );
};

export { Tabs };